import { observable, computed, action } from 'mobx';
import { Product, Cart, CartProduct } from '../models/interfaces';
import { API_URL } from '../constants/constants';

export class CartStore {

  @observable
  public cart: Cart;

  constructor(initial: Cart = { products: [] }) {
    this.cart = initial;
  }

  @computed
  get allProducts() {
    return this.cart.products;
  }

  @computed
  get allVermanProducts() {
    return this.cart.products.filter(product => product.company === 'Verman');
  }

  @computed
  get allBioteekkiProducts() {
    return this.cart.products.filter(product => product.company === 'Bioteekki');
  }

  @action
  addProduct(newProduct: Product, amount: number = 1, company: string = 'Verman') {
    if (this.findProductInCart(newProduct)) {
      this.cart.products = this.cart.products.map(product => {
        if (newProduct.Key === product.Key) {
          product.Quantity += amount;
        }
        return product;
      });
    } else {
      this.cart.products.push({ ...newProduct, Quantity: amount, company: company });
    }
    this.setLocalStorage();
  }

  @action
  subtractProduct(product: Product, amount: number = 1) {
    if (this.findProductInCart(product)) {
      this.cart.products = this.cart.products.map(item => {
        if (item.ItemNo === product.ItemNo) {
          item.Quantity -= amount;
        }
        return item;
      });

      this.cart.products = this.cart.products.filter(item => {
        return item.Quantity > 0;
      });
    }
    this.setLocalStorage();
  }

  @action
  setProductQuantity(product: Product, quantity: number) {
    if (this.findProductInCart(product)) {
      this.cart.products = this.cart.products.map(item => {
        if (item.ItemNo === product.ItemNo) {
          item.Quantity = quantity;
        }
        return item;
      });
    }
    this.setLocalStorage();
  }

  @action
  removeProduct(product: Product) {
    if (this.findProductInCart(product)) {
      this.cart.products = this.cart.products.filter(item => item.ItemNo !== product.ItemNo);
    }
    this.setLocalStorage();
  }

  @action
  findProductInCart(product: Product) {
    return this.cart.products.find(item => item.ItemNo === product.ItemNo);
  }

  @action
  clearStore() {
    this.cart.products = [];
    this.clearLocalStorage();
  }

  @action
  clearLocalStorage() {
    localStorage.removeItem('cart');
  }

  @action
  setLocalStorage() {
    localStorage.setItem('cart', JSON.stringify(this.cart));
  }

  @action
  getFromLocalStorage() {
    let storageString = localStorage.getItem('cart');

    if (storageString) {
      let parsedData: Cart = JSON.parse(storageString);

      if (parsedData.products.length) {
        this.cart = parsedData;
      }
    }
  }

}

export default CartStore;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/CartStore.ts